import { useState, useEffect } from 'react';
import useHealthSnapshotData from './useHealthSnapshotData';
import { getSliderParameters } from '../simulation/core/ParameterClassification';

const usePriorityParameters = (patientId) => {
  const [priorityParameters, setPriorityParameters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    loading: healthDataLoading,
    error: healthDataError,
    tableData,
  } = useHealthSnapshotData(patientId);

  useEffect(() => {
    if (healthDataLoading) {
      setLoading(true);
      return;
    }

    if (healthDataError) {
      setError(healthDataError);
      setLoading(false);
      return;
    }

    if (tableData && tableData.length > 0) {
      const allParams = tableData.flatMap(category => category.parameters);
      const sliderParams = getSliderParameters().map(p => p.key);
      
      const eligibleParams = allParams.filter(p => 
        sliderParams.includes(p.key) && 
        p.weightedAbsoluteZScore !== null && 
        !isNaN(p.weightedAbsoluteZScore)
      );

      eligibleParams.sort((a, b) => b.weightedAbsoluteZScore - a.weightedAbsoluteZScore);

      const topParams = eligibleParams.slice(0, 10);

      // Ensure our test parameters are included for now
      const testParams = ['vitals_weight', 'labs_inflammation_hscrp', 'labs_lipid_hdl'];
      testParams.forEach(testKey => {
        if (!topParams.some(p => p.key === testKey)) {
          const testParam = allParams.find(p => p.key === testKey);
          if (testParam) {
            topParams.push(testParam);
          }
        }
      });

      setPriorityParameters(topParams);
      setLoading(false);
    }
  }, [healthDataLoading, healthDataError, tableData]);

  return { loading, error, priorityParameters };
};

export default usePriorityParameters;
